import { Component, OnInit } from '@angular/core';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-facebook-cover',
    templateUrl: './facebook-cover.component.html',
    styleUrls: ['./facebook-cover.component.css']
})
export class FacebookCoverComponent implements OnInit {

    facebookCover = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.facebookCover = this.photos.facebookCover;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '1000px',
                data: {url: url}
            });
        }
    }

}
